import * as o from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/Pulse.es.js";
const e = o.forwardRef((t, s) => /* @__PURE__ */ o.createElement(r, { ref: s, ...t, weights: a }));
e.displayName = "PulseIcon";
const i = e;
export {
  e as ActivityIcon,
  i as Pulse,
  e as PulseIcon
};
